const IMAGE_MAX_WIDTH = 200;
const IMAGE_MAX_HEIGHT = 200;

export const dataUrlToFile = async (dataUrl: RequestInfo, file: any) => {
  const res = await fetch(dataUrl);
  const blob = await res.blob();
  return new File([blob], file.name, { type: file.type });
};

const processImg = (
  image: string,
  width: number,
  height: number,
  type: string | undefined
) => {
  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;

  const img = new Image();
  img.src = image;
  const ctx: any = canvas.getContext("2d");

  ctx.drawImage(img, 0, 0, width, height);

  return canvas.toDataURL(type, 0.8);
};

export const createImageThumbnail = async (file: any) => {
  return new Promise(resolve => {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      const image: any = new Image();
      image.onload = async () => {
        if (image.width > IMAGE_MAX_WIDTH || image.height > IMAGE_MAX_HEIGHT) {
          let width;
          let height;

          if (image.width > image.height) {
            height = image.height * (IMAGE_MAX_WIDTH / image.width);
            width = IMAGE_MAX_WIDTH;
          } else {
            width = image.width * (IMAGE_MAX_HEIGHT / image.height);
            height = IMAGE_MAX_HEIGHT;
          }
          const resizedImage = processImg(image.src, width, height, file.type);
          const resizedFile = await dataUrlToFile(resizedImage, file);
          resolve(resizedFile);
        }
        resolve(file);
      };

      image.src = e.target.result;
    };

    reader.readAsDataURL(file);
  });
};
